import * as React from 'react';

import { compose } from 'recompose';

import Retracked from 'js/app/retracked';
import { useLocation } from 'js/lib/useRouter';

import AccountPageHeader from 'bundles/composable-page-header-consumer/header-renderers/AccountPageHeader';
import UniversalPageFeatures from 'bundles/composable-page-header/components/UniversalPageFeatures';
import PageFooter from 'bundles/page-footer/components/PageFooter';
import CourseraMetatags from 'bundles/seo/components/CourseraMetatags';
import withMarketingConsent from 'bundles/user-consent/components/withMarketingConsent';

import 'css!bundles/accomplishments/styl/index';

type Props = {
  children: JSX.Element;
};

const AccomplishmentsApp = ({ children }: Props) => {
  const { pathname } = useLocation();

  const isCertificatePage = pathname.includes('certificate');
  return (
    <div className="rc-AccomplishmentsApp">
      <CourseraMetatags metaNameAndProperties={{ disableCrawlerIndexing: true }} />
      {!isCertificatePage && (
        <React.Fragment>
          <AccountPageHeader />
          <UniversalPageFeatures />
        </React.Fragment>
      )}
      <div style={{ minHeight: '60vh' }}>{children}</div>
      {!isCertificatePage && <PageFooter />}
    </div>
  );
};

export default compose<Props, {}>(
  Retracked.createTrackedContainer(() => {
    return {
      namespace: {
        app: 'accomplishments_v2',
        page: 'accomplishments_pages',
      },
    };
  }),
  withMarketingConsent
)(AccomplishmentsApp);
